import "./style/main.css";
import * as THREE from "three";
import imagesLoaded from "imagesloaded";
import gsap from 'gsap'
import ASScroll from "@ashthornton/asscroll";
import fragment from "./shaders/Fragment.glsl";
import vertex from "./shaders/Vertex.glsl";
import model from "../static/model1.jpg";
import Scroll from "./scroll.js"
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';


export default class Sketch {
	constructor(options) {
		this.time = 0;
		this.container = options.dom;
		this.scene = new THREE.Scene();

		this.width = this.container.offsetWidth;
		this.height = this.container.offsetHeight;
		this.fov = Math.atan(this.height / 2 / 600) * (180 / Math.PI) * 2;
		// console.log(this.fov);

		this.camera = new THREE.PerspectiveCamera(
			this.fov,
			this.width / this.height,
			100,
			2000
		);

		this.camera.position.z = 600;
		this.currentScroll = window.scrollY;

		this.raycaster = new THREE.Raycaster();
		this.mouse = new THREE.Vector2();

		this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
		this.renderer.setSize(this.width, this.height);
		this.container.appendChild(this.renderer.domElement);

		this.images = [...document.querySelectorAll("img")];
		this.images2 = [...document.querySelectorAll("img")];
		this.counter = 0


		/////////////////////////////////////////////////////////
		/////////////////////////////////////////////////////

		// const fontOpen = new Promise((resolve) => {
		// 	new FontFaceObserver("arial").load().then(() => {
		// 		resolve();
		// 	});
		// });

		// const fontPlayfair = new Promise((resolve) => {
		// 	new FontFaceObserver("Playfair Display").load().then(() => {
		// 		resolve();
		// 	});
		// });

		const preloadImages = new Promise((resolve, reject) => {
			imagesLoaded(
				document.querySelectorAll("img"),
				{ background: true },
				resolve
			);
		});

		let allComplete = [preloadImages];

		Promise.all(allComplete).then(() => {
			this.scroll = new ASScroll({
				disableRaf: true,
				disableResize: true,
			});
			this.scrollVelocity = new Scroll()
			this.scroll.enable();
			this.addImage();
			this.setPosition();
			this.mouseMovement();
			this.resize();
			this.setupResize();
			// this.addObjects();
			this.composerPass();
			this.events();
			this.render();
		});
	}

	mouseMovement() {
		window.addEventListener(
			"mousemove",
			(e) => {
				this.mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
				this.mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;

				this.raycaster.setFromCamera(this.mouse, this.camera);

				const intersects = this.raycaster.intersectObjects(this.scene.children);

				if(intersects.length > 0){
					let obj = intersects[0].object;
					obj.material.uniforms.hover.value = intersects[0].uv
				}
			},
			false
		);
	}

	setupResize() {
		window.addEventListener("resize", this.resize.bind(this));
	}

	resize() {
		this.width = this.container.offsetWidth;
		this.height = this.container.offsetHeight;

		this.renderer.setSize(this.width, this.height);

		this.camera.aspect = this.width / this.height;

		this.scroll.resize({ width: this.width, height: this.height });

		this.camera.updateProjectionMatrix();
	}

	addImage() {

		this.material = new THREE.ShaderMaterial({
			uniforms:{
				time:{value:0},
				uImage:{value:0},
				uImage2:{value:0},
				hover:{value: new THREE.Vector2(.5,.5)},
				hoverState:{value:0},
			},
			side: THREE.DoubleSide,
			fragmentShader: fragment,
			vertexShader: vertex,
			// wireframe: true,
		})

		this.materials = []
		this.textures = []


		this.imageStore = this.images.map((img) => {
			this.counter++
			let bounds = img.getBoundingClientRect();

			let geometry = new THREE.PlaneBufferGeometry(
				bounds.width,
				bounds.height,
				10,
				10
			);


			let texture = new THREE.Texture(img);
			let texture2 = new THREE.Texture(this.images[Math.floor(Math.random()*16)])
			// console.log(img)
			texture.needsUpdate = true;
			texture2.needsUpdate = true;
			// let material = new THREE.MeshBasicMaterial({ map: texture });

	
			let material = this.material.clone();
			

	img.addEventListener('mouseenter', ()=>{
		gsap.to(material.uniforms.hoverState, {
			duration: 1,
			value: 1
		})
	})

	img.addEventListener('mouseout', ()=>{
		gsap.to(material.uniforms.hoverState, {
			duration: 1,
			value: 0
		})
	})

			this.materials.push(material)

			material.uniforms.uImage.value = texture;
			material.uniforms.uImage2.value = texture2;

			let mesh = new THREE.Mesh(geometry, material);

			this.scene.add(mesh);

			return {
				img: img,
				mesh: mesh,
				top: bounds.top,
				left: bounds.left,
				width: bounds.width,
				height: bounds.height,
			};
		});
	}

	setPosition() {
		this.imageStore.forEach((o) => {
			o.mesh.position.y =
				this.currentScroll - o.top + this.height / 2 - o.height / 2;
			o.mesh.position.x = o.left - this.width / 2 + o.width / 2;
		});
	}

	addObjects() {
		for (let i = 0; i < 5; i++) {
			this.geometry = new THREE.PlaneBufferGeometry(200, 400, 10, 10);
			this.material = new THREE.MeshNormalMaterial();

			this.Mesh = new THREE.Mesh(this.geometry, this.material);
			this.scene.add(this.Mesh);
		}
	}

	composerPass(){
    this.composer = new EffectComposer(this.renderer);
    this.renderPass = new RenderPass(this.scene, this.camera);
    this.composer.addPass(this.renderPass);

    //custom shader pass
    var counter = 0.0;
    this.myEffect = {
      uniforms: {
        "tDiffuse": { value: null },
		"scrollspeed": {value : null}
      },
      vertexShader: `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix 
          * modelViewMatrix 
          * vec4( position, 1.0 );
      }
      `,
      fragmentShader: `
      uniform sampler2D tDiffuse;
      varying vec2 vUv;
	  uniform float scrollspeed;
      void main(){
        vec2 newUV = vUv;
		float area = smoothstep(.4, 0. ,vUv.y) *scrollspeed;
		area = pow(area, 2.);
		newUV.x -= (vUv.x - .5)*.05*area;
        gl_FragColor = texture2D( tDiffuse, newUV);
		// gl_FragColor = vec4(area, 0., 0., 1.);
      }
      `
    }

    this.customPass = new ShaderPass(this.myEffect);
    this.customPass.renderToScreen = true;
    
    this.composer.addPass(this.customPass);
  }

  events(){
	  
	window.addEventListener('wheel', ()=>{

		if(this.scroll.currentPos !== 0){
			gsap.to(this.customPass.uniforms.scrollspeed, {
			value : .9,
			duration: 1
		})
		}

	})
  }


	render() {

	

		this.time += 0.05;

		this.scroll.update();
		this.currentScroll = this.scroll.currentPos;
		this.setPosition();

		this.materials.forEach(m=>{
			m.uniforms.time.value = this.time
		})

		// this.renderer.render(this.scene, this.camera);
		this.composer.render()

		// this.material.uniforms.time.value = this.time;
		window.requestAnimationFrame(this.render.bind(this));
	}
}

new Sketch({
	dom: document.querySelector(".container"),
});
